import { type ReactNode } from 'react';

import { MediaStudioDialog, type MediaStudioMeta } from '../media-studio/MediaStudioDialog';
import { type SuggestionChip } from '../media-studio/SuggestionChips';

export interface VideoStudioDialogContext {
  jobId: string;
  videoUrl: string;
  prompt?: string;
  model?: string;
  duration?: number;
  aspectRatio?: string;
}

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  videoUrl: string;
  posterUrl?: string;
  title: string;
  meta: MediaStudioMeta;
  thumbnailUrl?: string;
  savedToLibrary?: boolean;
  isFastTier?: boolean;
  onRegenerate?: () => void;
  onVariations?: () => void;
  onExtend?: () => void;
  onDownload?: () => void;
  onSaveToPlan?: () => void;
  onCreatePost?: () => void;
  isCreatingPost?: boolean;
  onChipAction?: (chip: SuggestionChip) => void;
  inline?: boolean;
  breadcrumb?: { rootLabel: string; rootHref?: string | undefined; leafLabel: string } | undefined;
  context?: VideoStudioDialogContext;
  artifactId?: string | null;
  artifactKind?: string;
  isOperating?: boolean;
  activeOperationId?: string | null;
}

export function VideoStudioDialog(props: Props): ReactNode {
  const ctx = props.context;
  if (!ctx) return null;

  return (
    <MediaStudioDialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      inline={props.inline}
      {...(props.breadcrumb ? { breadcrumb: props.breadcrumb } : {})}
      savedToLibrary={props.savedToLibrary}
      onDownload={props.onDownload}
      onSaveToPlan={props.onSaveToPlan}
      onCreatePost={props.onCreatePost}
      isCreatingPost={props.isCreatingPost}
      onVariations={props.onVariations}
      onExtend={props.onExtend}
      onChipAction={props.onChipAction}
      artifactId={props.artifactId}
      artifactKind={props.artifactKind}
      isOperating={props.isOperating}
      activeOperationId={props.activeOperationId}
      payload={{
        kind: 'video',
        url: props.videoUrl,
        posterUrl: props.posterUrl,
        title: props.title,
        meta: props.meta,
        isFastTier: props.isFastTier ?? true,
        context: { kind: 'video', ...ctx },
        thumbnailUrl: props.thumbnailUrl ?? props.posterUrl,
      }}
    />
  );
}
